import { render } from "./Descuentos.vue?vue&type=template&id=64e27262&scoped=true"
import script from "./Descuentos.vue?vue&type=script&lang=js"
export * from "./Descuentos.vue?vue&type=script&lang=js"

import "./Descuentos.vue?vue&type=style&index=0&id=64e27262&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e27262"]])

export default __exports__